import { ADD_BOOKING_PAYMENT_FAILURE, ADD_BOOKING_PAYMENT_REQUEST, ADD_BOOKING_PAYMENT_RESET, ADD_BOOKING_PAYMENT_SUCCESS } from "../../../../redux/types/pvs"



const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const addBookingPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BOOKING_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case ADD_BOOKING_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case ADD_BOOKING_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: ""
      }

    case ADD_BOOKING_PAYMENT_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default addBookingPaymentReducer
